module.exports = __webpack_public_path__ + "img/Tutorial_selected.4e3853cd.svg";